import { Logger } from '@as-react/logger';
import { createStore as createDynamicStore } from 'redux-dynamic-modules';
import { getSagaExtension } from 'redux-dynamic-modules-saga';
import { createDynamicModuleLoaderAnalyticsAdobeTagManager } from '../middleware/analyticsAdobeTagManagerMiddlewareBuilder';
import { createDynamicModuleLoaderAnalyticsCriteo } from '../middleware/analyticsCriteoMiddlewareBuilder';
import { createDynamicModuleLoaderAnalyticsGoogleTagManager } from '../middleware/analyticsGoogleTagManagerMiddlewareBuilder';
import { createDynamicModuleLoaderRouterMiddleWare } from '../middleware/routerMiddlewareBuilder';
import loadRouterModule from '../rootModules/modules/Router.module';
import createDynamicModuleLoaderCustomEvent from '../middleware/customEventMiddlewareBuilder';
import { generateAemConfiguration } from '@as-react/common-components';
export const configureDynamicStoreBase = (initialState, context, dynamicStore, componentReduxModules, history, composeEnhancers) => {
    if (!dynamicStore.getStore()) {
        if (context.aemConfiguration) {
            context.aemConfiguration = generateAemConfiguration(context.aemConfiguration);
        }
        dynamicStore.setStore(createDynamicStore({
            initialState: initialState,
            extensions: [getSagaExtension(context)],
            enhancers: Logger.reduxEnhancer ? [Logger.reduxEnhancer] : undefined,
            advancedComposeEnhancers: composeEnhancers,
        }, 
        /* Custom compose */
        createDynamicModuleLoaderAnalyticsAdobeTagManager(), createDynamicModuleLoaderAnalyticsCriteo(), createDynamicModuleLoaderAnalyticsGoogleTagManager(), createDynamicModuleLoaderCustomEvent()));
    }
    if (componentReduxModules) {
        if (Array.isArray(componentReduxModules)) {
            dynamicStore.getStore().addModules(componentReduxModules);
        }
        else {
            dynamicStore.getStore().addModule(componentReduxModules);
        }
    }
    if (history) {
        dynamicStore.getStore().addModules([loadRouterModule(history), createDynamicModuleLoaderRouterMiddleWare(history)]);
    }
    return dynamicStore.getStore();
};
